// Ce que le magasin renseigne est l'adresse électronique de facturation attendue par
// Pennylane. Son format dépend de l'enseigne (HUB-886) : SIRET_GLN pour Leclerc
// (SIRET ou SIREN, un tiret bas, les 13 chiffres du GLN, ex. 339377467_3025500060368,
// sans clé de contrôle — HUB-899), code de routage de la centrale ou SIREN seul pour
// les autres enseignes (Intermarché, Super U…).
const GLN_PATTERN = /^(\d{14}|\d{9})_\d{13}$/
const ROUTAGE_PATTERN = /^[A-Za-z0-9._-]{3,30}$/

export const GLN_EXAMPLE = '339377467_3025500060368'
export const GLN_FORMAT_HINT = 'SIRET_GLN : votre SIRET (ou SIREN), un tiret bas, puis les 13 chiffres du GLN'

export const cleanGln = (gln) => String(gln || '').replace(/\s/g, '')

export const isValidGln = (gln) => GLN_PATTERN.test(cleanGln(gln))

export const GLN_MODES = {
  leclerc: {
    key: 'leclerc',
    label: 'GLN de facturation',
    heading: 'Quel est le GLN de facturation de votre magasin ?',
    hint: GLN_FORMAT_HINT,
    example: GLN_EXAMPLE,
    counter: 28,
    isValid: isValidGln,
  },
  routage: {
    key: 'routage',
    label: 'Code de routage ou SIREN',
    heading: 'Quel est le code de routage ou le SIREN de facturation de votre magasin ?',
    hint: 'Code de routage communiqué par votre centrale, ou SIREN de votre société (9 chiffres)',
    example: '339377467',
    counter: 30,
    isValid: (value) => ROUTAGE_PATTERN.test(cleanGln(value)),
  },
}

export const glnModeFor = (enseigne) => (/leclerc/i.test(String(enseigne || '')) ? GLN_MODES.leclerc : GLN_MODES.routage)
